import { makeStyles } from '@rbx/ui';

const useResourcePathSelectListStyles = makeStyles()((theme) => ({
  list: {
    padding: 0,
    maxWidth: '100%',
  },
  listHeader: {
    paddingLeft: 0,
    maxWidth: '100%',
  },
  listItem: {
    cursor: 'pointer',
    padding: theme.spacing(0.5),
    paddingLeft: 0,
    maxWidth: '100%',
  },
  maxWidth100: {
    maxWidth: '100%',
  },
}));

export default useResourcePathSelectListStyles;
